import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const formatValues = (value, type) => {
  if (!value) return null;
  switch (type) {
    case 'market':
    case 'scar':
      return `$${Math.round(value).toLocaleString()}`;
    case 'offer':
      return `$${value.toLocaleString()}`;
    case 'percentage':
      return `${(value).toFixed(2)}%`;
    case 'av':
      return `${Math.round(value).toLocaleString()}`;
    default:
      return value;
  }
};

const ValueCell = React.memo(({ value, loading, type, impliedReduction, pctReduction, decimalPlaces = 2 }) => {
  if (loading || value === 'loading') {
    return (
      <CircularProgress 
        size={16} 
        sx={{ 
          display: 'inline-block',
          verticalAlign: 'middle'
        }} 
      />
    );
  }
  if (value == null || isNaN(value)) return <span style={{ color: '#888', fontStyle: 'italic' }}>None</span>;
  
  const formattedValue = formatValues(value, type);
  
  // For percentage type, apply color coding based on the value
  if (type === 'percentage') {
    const reductionColor = value >= 0 ? 'red' : 'green';
    return (
      <span style={{ 
        color: reductionColor, 
        fontWeight: 'bold'
      }}>
        {formattedValue}
      </span>
    );
  }
  
  // Add percentage if available (either impliedReduction or pctReduction)
  const percentage = impliedReduction !== null && !isNaN(impliedReduction) ? impliedReduction : 
                    pctReduction !== null && !isNaN(pctReduction) ? pctReduction : null;
  
  if (percentage !== null) {
    const reductionColor = percentage >= 0 ? 'red' : 'green';
    return (
      <span>
        {formattedValue}
        <span style={{ 
          color: reductionColor, 
          fontSize: '0.85em', 
          marginLeft: '4px',
          fontWeight: 'normal'
        }}>
          ({percentage.toLocaleString(undefined, {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces,
          })}%)
        </span>
      </span>
    );
  }
  
  return <span>{formattedValue}</span>;
});

export default ValueCell; 